import { faker } from '@faker-js/faker'

import { District, NeighborhoodVicinity } from '../../contracts/district/district'
import { asBuilder } from '../asBuilder'

export const getRandomDistrict = asBuilder((): District => {
  return {
    name: faker.string.uuid(),
    neighborhoodVicinities: faker.helpers.multiple(getRandomNeighborVicinity),
  }
})

export const getRandomNeighborVicinity = asBuilder((): NeighborhoodVicinity => {
  return {
    code: faker.string.uuid(),
    name: faker.string.uuid(),
  }
})
